import { Injectable, inject } from '@angular/core';
import { AttributeResource } from '@df/catalog/attribute/attribute.resource';
import { Category, ICategoryDataV2 } from '@df/catalog/category/category';
import { FacetUrlService } from '@df/module-facet-url/core/facet-url.service';
import intersection from 'lodash-es/intersection';

declare module '@df/catalog/category/category' {
    interface ICategoryDataV2 {
        /**
         * Allowed attributes
         * Allowed attributes
         */
        facetattrs: {
            attribute_code: string;
            attribute_options: number[];
        }[];
    }
}
declare module '@df/catalog/catalog.interfaces' {
    namespace Catalog {
        interface IAttributeOption {
            /**
             * Only indexable options can be used in facet urls
             */
            indexable?: 1 | 0;
        }
    }
}

@Injectable({
    providedIn: 'root'
})
export class FacetUrlServiceDecorator extends FacetUrlService {
    private attributeResource = inject(AttributeResource);

    /**
     * Retrieves ordered list of attributes used for facet URLs
     */
    override getFacetAttributes(category: Category<ICategoryDataV2>, data: Record<string, string | number | string[]>): string[] {
        const globalPattern = super.getFacetAttributes(category, data);
        const categoryAttrs = category.data?.facetattrs?.map(attr => attr.attribute_code) || [];

        const dataAttrs = Object.keys(data);
        const attrs = intersection(globalPattern, categoryAttrs, dataAttrs);

        return attrs.filter(attr => {
            let label = data[attr];
            if (!label) {
                return false;
            }
            if (Array.isArray(label)) {
                if (label.length !== 1) {
                    return false;
                }
                label = label[0] as string | number;
            }
            
            const attribute = this.attributeResource.getExisting(attr);

            const value = attribute?.getOptionValue(label);

            const option = attribute?.getOptionByValue(Number(value));
            const attributeOptions = category.data?.facetattrs?.find(a => a.attribute_code === attr)?.attribute_options;

            if (option && attributeOptions) {
                return attributeOptions.includes(option.value);
            }

            return typeof value === 'number' && attribute?.getOptionByValue(value)?.indexable;
        });
    }
}
